if (!customElements.get('yst-stock-badge')) {
  customElements.define('yst-stock-badge', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      this.productRoot = this.closest('.main-product');
      this.label = this.querySelector('[data-stock-label]');
      const data = this.querySelector('[data-stock-variants]');
      if (!this.productRoot || !this.label || !data) return;
      try {
        this.variants = JSON.parse(data.textContent);
      } catch {
        this.style.display = 'none';
        return;
      }
      const options = { signal: this.abortController.signal };
      this.productRoot.addEventListener('change', (event) => {
        const picker = event.target.closest('variant-picker');
        if (picker && this.productRoot.contains(picker)) {
          const input = event.target.tagName === 'SELECT'
            ? event.target.selectedOptions[0]
            : event.target;
          const resource = Array.from(picker.querySelectorAll('script[data-resource]'))
            .find((script) => script.dataset.resource === input?.id);
          try {
            this.render(resource ? JSON.parse(resource.textContent)?.id : null);
          } catch {
            this.render(null);
          }
          return;
        }
        const form = this.ownerDocument.getElementById(this.dataset.productFormId);
        if (event.target.name === 'id' && form?.contains(event.target)) {
          this.render(event.target.value);
        }
      }, options);
      window.addEventListener('popstate', () => this.syncFromUrl(), options);
      window.addEventListener('pageshow', () => this.syncFromUrl(), options);
      this.syncFromUrl();
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    syncFromUrl() {
      const variant = new URL(window.location.href).searchParams.get('variant');
      this.render(variant || this.dataset.initialVariant);
    }

    render(variantId) {
      const message = this.variants?.[String(variantId)];
      this.label.textContent = message || '';
      this.style.display = message ? 'inline-block' : 'none';
      this.dataset.variantId = variantId == null ? '' : String(variantId);
    }
  });
}
